export const getAssessmentFilterCacheKey = (skillId, levelCount) =>
  `${Number(skillId) || 0}:${Number(levelCount) || 0}`;

export const resetAssessmentFilterCache = (cacheRef, cacheKey) => {
  cacheRef.current = { key: cacheKey, filters: [] };
};

export const resolveAssessmentFilters = ({
  responseFilters = [],
  pageOffset = 0,
  cacheRef,
  cacheKey,
  transformFilters = (filters) => filters,
}) => {
  const filtersFromResponse = Array.isArray(responseFilters)
    ? responseFilters
    : [];
  const transformedFilters = transformFilters(filtersFromResponse);
  const normalizedFilters = Array.isArray(transformedFilters)
    ? transformedFilters
    : [];

  if (!cacheRef.current || cacheRef.current.key !== cacheKey) {
    resetAssessmentFilterCache(cacheRef, cacheKey);
  }

  if (pageOffset === 0 || normalizedFilters.length > 0) {
    cacheRef.current = { key: cacheKey, filters: normalizedFilters };
    return normalizedFilters;
  }

  return cacheRef.current.filters;
};
